import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ContactForm from "../components/km/ContactForm";
import { KM, IMAGES } from "../data/km";

export default function ContactPage() {
  const [sp] = useSearchParams();
  const interest = sp.get("interest") || "";
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main className="pt-[76px] md:pt-[84px]" data-testid="contact-page">
      <section className="px-6 md:px-12 lg:px-16 py-20 md:py-28 lg:py-32 bg-white">
        <div className="max-w-[1180px] mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <div className="km-fade">
            <p className="km-eyebrow text-[11px] lg:text-[12.5px] mb-6 text-[#2C4A3B]">Get in Touch</p>
            <h1 className="km-serif text-[52px] sm:text-[64px] lg:text-[80px] leading-[1.02] text-[#141414] mb-6">Let's <em>connect.</em></h1>
            <p className="km-serif italic text-[22px] sm:text-[24px] lg:text-[28px] leading-[1.35] text-[#2C4A3B] mb-8">{KM.motto}</p>
            <p className="km-body text-[#141414] max-w-[480px] mb-10">Buying, selling, or ready to elevate your space? Share a few details and Kristin will personally reach out to talk through your goals, your timing, and your next move.</p>
            <div className="sm:space-y-2 text-[15px] sm:text-[14px] text-[#141414]" data-testid="contact-details">
              <p className="km-eyebrow text-[11px] lg:text-[12.5px] text-[#2C4A3B] mb-3">Contact</p>
              <a href={`tel:${KM.phone}`} className="block max-sm:py-2.5 hover:opacity-60 transition-opacity" data-testid="contact-page-phone">{KM.phone}</a>
              <a href={`mailto:${KM.email}`} className="block max-sm:py-2.5 break-all hover:opacity-60 transition-opacity" data-testid="contact-page-email">{KM.email}</a>
              <a href={KM.instagramUrl} target="_blank" rel="noopener noreferrer" className="block max-sm:py-2.5 hover:opacity-60 transition-opacity" data-testid="contact-page-instagram">{KM.instagram}</a>
            </div>
            <div className="hidden lg:block mt-14 overflow-hidden max-w-[420px]"><img src={IMAGES.homeFeels} alt="Styled books and bowl" className="w-full aspect-[4/3] object-cover km-zoom" /></div>
          </div>
          <div className="bg-[#F4F3EF] p-7 sm:p-10 lg:p-12 km-fade" style={{ animationDelay: ".2s" }}>
            <ContactForm interest={interest} />
          </div>
        </div>
      </section>
    </main>
  );
}
